// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.theme--dark .innerHtmlContent *, .theme--dark .innerHtmlContent a {
   color: #fff !important;
   background-color:transparent !important;
}

/*.theme--dark .innerHtmlContent .expand-content *:not(.theme--dark .innerHtmlContent .expand-control *) {
   color: black;
}
.theme--dark .innerHtmlContent table.confluenceTable td.confluenceTd[data-highlight-colour="#f4f5f7"] * {
   color: #172b4d;
}*/

.theme--dark .euiPanel.euiPanel--plain {
   background-color: #070F30;
   color: #fff;
}

.theme--dark div#contentPage > div:last-child > div:nth-child(2) > div:first-child > div > div:last-child > button > span {
   color: white !important;
}

.theme--dark div#contentPage > div:last-child > div:nth-child(2) > div:first-child > div > div:last-child > button.euiTab-isSelected > span {
   color: #5076ff !important;
}

.euiPageContentBody {
   margin-left: 20px;
}

.height300 {
   height: 300px;
}

/* Styles spécifiques pour la page d'aide - mode sombre */
.theme--dark .euiPanel {
    background-color: #070F30 !important;
    color: #fff !important;
}

.theme--dark .euiPanel * {
    color: #fff !important;
}

.theme--dark .euiCard {
    background-color: #1E203D !important;
    color: #fff !important;
}

.theme--dark .euiCard * {
    color: #fff !important;
}

.theme--dark .euiAccordion .euiAccordion__button {
    color: #fff !important;
}

.theme--dark .euiAccordion .euiAccordion__button:hover {
    color: #5076ff !important;
}

.theme--dark .euiCallOut {
    background-color: #1E203D !important;
    color: #fff !important;
}

.theme--dark .euiCallOut * {
    color: #fff !important;
}

.theme--dark .euiListGroup .euiListGroupItem__label {
    color: #fff !important;
}

.theme--dark .euiText {
    color: #fff !important;
}

.theme--dark .euiText * {
    color: #fff !important;
}

.theme--dark .euiTitle h1,
.theme--dark .euiTitle h2,
.theme--dark .euiTitle h3,
.theme--dark .euiTitle h4,
.theme--dark .euiTitle h5,
.theme--dark .euiTitle h6 {
    color: #fff !important;
}

.theme--dark .euiBadge {
    background-color: #5076ff !important;
    color: #fff !important;
}

.theme--dark .euiSteps .euiStep__title {
    color: #fff !important;
}

.theme--dark .euiSteps .euiStep__children {
    color: #fff !important;
}

.theme--dark .euiButton {
    color: #fff !important;
}

.theme--dark .euiButton * {
    color: #fff !important;
}

/* Styles plus spécifiques pour forcer la visibilité */
.theme--dark p,
.theme--dark span,
.theme--dark div,
.theme--dark li,
.theme--dark ul,
.theme--dark ol {
    color: #fff !important;
}

.theme--dark strong,
.theme--dark b {
    color: #fff !important;
}

.theme--dark .euiFlexGroup,
.theme--dark .euiFlexItem {
    color: #fff !important;
}

.theme--dark .euiFlexGroup *,
.theme--dark .euiFlexItem * {
    color: #fff !important;
}

/* Styles pour les balises pre en mode sombre */
.theme--dark pre {
    background-color: #000000 !important;
    color: #d4d4d4 !important;
    border: 1px solid #3e3e3e !important;
    border-radius: 4px !important;
    padding: 12px !important;
    overflow-x: auto !important;
}

.theme--dark pre code {
    background-color: #000000 !important;
    color: #d4d4d4 !important;
}

/* Styles pour les éléments pre dans les EuiCodeBlock */
.theme--dark .euiCodeBlock pre {
    background-color: #000000 !important;
    color: #d4d4d4 !important;
}

.theme--dark .euiCodeBlock pre code {
    background-color: #000000 !important;
    color: #d4d4d4 !important;
}

/* Styles pour les EuiCodeBlock en mode sombre */
.theme--dark .euiCodeBlock {
    background-color: #000000 !important;
    color: #d4d4d4 !important;
    border: 1px solid #3e3e3e !important;
}

.theme--dark .euiCodeBlock code {
    background-color: #000000 !important;
    color: #d4d4d4 !important;
}

/* Styles pour les tables en mode sombre */
.theme--dark table {
    background-color: #1e1e1e !important;
    color: #fff !important;
    border-collapse: collapse !important;
}

.theme--dark table th {
    background-color: #2d2d2d !important;
    color: #fff !important;
    border: 1px solid #3e3e3e !important;
    padding: 8px 12px !important;
    font-weight: bold !important;
}

.theme--dark table td {
    background-color: #1e1e1e !important;
    color: #fff !important;
    border: 1px solid #3e3e3e !important;
    padding: 8px 12px !important;
}

.theme--dark table tr:nth-child(even) td {
    background-color: #2d2d2d !important;
}

.theme--dark table tr:hover td {
    background-color: #3e3e3e !important;
}

/* Styles pour les EuiTable en mode sombre */
.theme--dark .euiTable {
    background-color: #1e1e1e !important;
    color: #fff !important;
}

.theme--dark .euiTable .euiTableHeader {
    background-color: #2d2d2d !important;
}

.theme--dark .euiTable .euiTableHeaderCell {
    background-color: #2d2d2d !important;
    color: #fff !important;
    border-bottom: 1px solid #3e3e3e !important;
}

.theme--dark .euiTable .euiTableBody {
    background-color: #1e1e1e !important;
}

.theme--dark .euiTable .euiTableRow {
    background-color: #1e1e1e !important;
}

.theme--dark .euiTable .euiTableRow:nth-child(even) {
    background-color: #2d2d2d !important;
}

.theme--dark .euiTable .euiTableRow:hover {
    background-color: #3e3e3e !important;
}

.theme--dark .euiTable .euiTableRowCell {
    background-color: transparent !important;
    color: #fff !important;
    border-bottom: 1px solid #3e3e3e !important;
}

.theme--dark .euiTable .euiTableRowCell * {
    color: #fff !important;
}
`, "",{"version":3,"sources":["webpack://./src/styles/custom.css"],"names":[],"mappings":"AAAA;GACG,sBAAsB;GACtB,uCAAuC;AAC1C;;AAEA;;;;;EAKE;;AAEF;GACG,yBAAyB;GACzB,WAAW;AACd;;AAEA;GACG,uBAAuB;AAC1B;;AAEA;GACG,yBAAyB;AAC5B;;AAEA;GACG,iBAAiB;AACpB;;AAEA;GACG,aAAa;AAChB;;AAEA,yDAAyD;AACzD;IACI,oCAAoC;IACpC,sBAAsB;AAC1B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,oCAAoC;IACpC,sBAAsB;AAC1B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,oCAAoC;IACpC,sBAAsB;AAC1B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;;;;;;IAMI,sBAAsB;AAC1B;;AAEA;IACI,oCAAoC;IACpC,sBAAsB;AAC1B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA,sDAAsD;AACtD;;;;;;IAMI,sBAAsB;AAC1B;;AAEA;;IAEI,sBAAsB;AAC1B;;AAEA;;IAEI,sBAAsB;AAC1B;;AAEA;;IAEI,sBAAsB;AAC1B;;AAEA,+CAA+C;AAC/C;IACI,oCAAoC;IACpC,yBAAyB;IACzB,oCAAoC;IACpC,6BAA6B;IAC7B,wBAAwB;IACxB,2BAA2B;AAC/B;;AAEA;IACI,oCAAoC;IACpC,yBAAyB;AAC7B;;AAEA,uDAAuD;AACvD;IACI,oCAAoC;IACpC,yBAAyB;AAC7B;;AAEA;IACI,oCAAoC;IACpC,yBAAyB;AAC7B;;AAEA,gDAAgD;AAChD;IACI,oCAAoC;IACpC,yBAAyB;IACzB,oCAAoC;AACxC;;AAEA;IACI,oCAAoC;IACpC,yBAAyB;AAC7B;;AAEA,0CAA0C;AAC1C;IACI,oCAAoC;IACpC,sBAAsB;IACtB,oCAAoC;AACxC;;AAEA;IACI,oCAAoC;IACpC,sBAAsB;IACtB,oCAAoC;IACpC,4BAA4B;IAC5B,4BAA4B;AAChC;;AAEA;IACI,oCAAoC;IACpC,sBAAsB;IACtB,oCAAoC;IACpC,4BAA4B;AAChC;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,oCAAoC;AACxC;;AAEA,4CAA4C;AAC5C;IACI,oCAAoC;IACpC,sBAAsB;AAC1B;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,oCAAoC;IACpC,sBAAsB;IACtB,2CAA2C;AAC/C;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,wCAAwC;IACxC,sBAAsB;IACtB,2CAA2C;AAC/C;;AAEA;IACI,sBAAsB;AAC1B","sourcesContent":[".theme--dark .innerHtmlContent *, .theme--dark .innerHtmlContent a {\n   color: #fff !important;\n   background-color:transparent !important;\n}\n\n/*.theme--dark .innerHtmlContent .expand-content *:not(.theme--dark .innerHtmlContent .expand-control *) {\n   color: black;\n}\n.theme--dark .innerHtmlContent table.confluenceTable td.confluenceTd[data-highlight-colour=\"#f4f5f7\"] * {\n   color: #172b4d;\n}*/\n\n.theme--dark .euiPanel.euiPanel--plain {\n   background-color: #070F30;\n   color: #fff;\n}\n\n.theme--dark div#contentPage > div:last-child > div:nth-child(2) > div:first-child > div > div:last-child > button > span {\n   color: white !important;\n}\n\n.theme--dark div#contentPage > div:last-child > div:nth-child(2) > div:first-child > div > div:last-child > button.euiTab-isSelected > span {\n   color: #5076ff !important;\n}\n\n.euiPageContentBody {\n   margin-left: 20px;\n}\n\n.height300 {\n   height: 300px;\n}\n\n/* Styles spécifiques pour la page d'aide - mode sombre */\n.theme--dark .euiPanel {\n    background-color: #070F30 !important;\n    color: #fff !important;\n}\n\n.theme--dark .euiPanel * {\n    color: #fff !important;\n}\n\n.theme--dark .euiCard {\n    background-color: #1E203D !important;\n    color: #fff !important;\n}\n\n.theme--dark .euiCard * {\n    color: #fff !important;\n}\n\n.theme--dark .euiAccordion .euiAccordion__button {\n    color: #fff !important;\n}\n\n.theme--dark .euiAccordion .euiAccordion__button:hover {\n    color: #5076ff !important;\n}\n\n.theme--dark .euiCallOut {\n    background-color: #1E203D !important;\n    color: #fff !important;\n}\n\n.theme--dark .euiCallOut * {\n    color: #fff !important;\n}\n\n.theme--dark .euiListGroup .euiListGroupItem__label {\n    color: #fff !important;\n}\n\n.theme--dark .euiText {\n    color: #fff !important;\n}\n\n.theme--dark .euiText * {\n    color: #fff !important;\n}\n\n.theme--dark .euiTitle h1,\n.theme--dark .euiTitle h2,\n.theme--dark .euiTitle h3,\n.theme--dark .euiTitle h4,\n.theme--dark .euiTitle h5,\n.theme--dark .euiTitle h6 {\n    color: #fff !important;\n}\n\n.theme--dark .euiBadge {\n    background-color: #5076ff !important;\n    color: #fff !important;\n}\n\n.theme--dark .euiSteps .euiStep__title {\n    color: #fff !important;\n}\n\n.theme--dark .euiSteps .euiStep__children {\n    color: #fff !important;\n}\n\n.theme--dark .euiButton {\n    color: #fff !important;\n}\n\n.theme--dark .euiButton * {\n    color: #fff !important;\n}\n\n/* Styles plus spécifiques pour forcer la visibilité */\n.theme--dark p,\n.theme--dark span,\n.theme--dark div,\n.theme--dark li,\n.theme--dark ul,\n.theme--dark ol {\n    color: #fff !important;\n}\n\n.theme--dark strong,\n.theme--dark b {\n    color: #fff !important;\n}\n\n.theme--dark .euiFlexGroup,\n.theme--dark .euiFlexItem {\n    color: #fff !important;\n}\n\n.theme--dark .euiFlexGroup *,\n.theme--dark .euiFlexItem * {\n    color: #fff !important;\n}\n\n/* Styles pour les balises pre en mode sombre */\n.theme--dark pre {\n    background-color: #000000 !important;\n    color: #d4d4d4 !important;\n    border: 1px solid #3e3e3e !important;\n    border-radius: 4px !important;\n    padding: 12px !important;\n    overflow-x: auto !important;\n}\n\n.theme--dark pre code {\n    background-color: #000000 !important;\n    color: #d4d4d4 !important;\n}\n\n/* Styles pour les éléments pre dans les EuiCodeBlock */\n.theme--dark .euiCodeBlock pre {\n    background-color: #000000 !important;\n    color: #d4d4d4 !important;\n}\n\n.theme--dark .euiCodeBlock pre code {\n    background-color: #000000 !important;\n    color: #d4d4d4 !important;\n}\n\n/* Styles pour les EuiCodeBlock en mode sombre */\n.theme--dark .euiCodeBlock {\n    background-color: #000000 !important;\n    color: #d4d4d4 !important;\n    border: 1px solid #3e3e3e !important;\n}\n\n.theme--dark .euiCodeBlock code {\n    background-color: #000000 !important;\n    color: #d4d4d4 !important;\n}\n\n/* Styles pour les tables en mode sombre */\n.theme--dark table {\n    background-color: #1e1e1e !important;\n    color: #fff !important;\n    border-collapse: collapse !important;\n}\n\n.theme--dark table th {\n    background-color: #2d2d2d !important;\n    color: #fff !important;\n    border: 1px solid #3e3e3e !important;\n    padding: 8px 12px !important;\n    font-weight: bold !important;\n}\n\n.theme--dark table td {\n    background-color: #1e1e1e !important;\n    color: #fff !important;\n    border: 1px solid #3e3e3e !important;\n    padding: 8px 12px !important;\n}\n\n.theme--dark table tr:nth-child(even) td {\n    background-color: #2d2d2d !important;\n}\n\n.theme--dark table tr:hover td {\n    background-color: #3e3e3e !important;\n}\n\n/* Styles pour les EuiTable en mode sombre */\n.theme--dark .euiTable {\n    background-color: #1e1e1e !important;\n    color: #fff !important;\n}\n\n.theme--dark .euiTable .euiTableHeader {\n    background-color: #2d2d2d !important;\n}\n\n.theme--dark .euiTable .euiTableHeaderCell {\n    background-color: #2d2d2d !important;\n    color: #fff !important;\n    border-bottom: 1px solid #3e3e3e !important;\n}\n\n.theme--dark .euiTable .euiTableBody {\n    background-color: #1e1e1e !important;\n}\n\n.theme--dark .euiTable .euiTableRow {\n    background-color: #1e1e1e !important;\n}\n\n.theme--dark .euiTable .euiTableRow:nth-child(even) {\n    background-color: #2d2d2d !important;\n}\n\n.theme--dark .euiTable .euiTableRow:hover {\n    background-color: #3e3e3e !important;\n}\n\n.theme--dark .euiTable .euiTableRowCell {\n    background-color: transparent !important;\n    color: #fff !important;\n    border-bottom: 1px solid #3e3e3e !important;\n}\n\n.theme--dark .euiTable .euiTableRowCell * {\n    color: #fff !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
